import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface GlobalSearchEmail {
  id: number;
  from: string;
  subject: string | null;
  preview: string | null;
  timestamp: string;
}

export interface GlobalSearchContact {
  id: number;
  fullName: string | null;
  primaryEmail: string | null;
  businessName: string | null;
}

export interface GlobalSearchLead {
  id: string;
  businessName: string;
  category: string | null;
  city: string | null;
  pipelineStage: string;
}

export interface GlobalSearchReport {
  id: number;
  slug: string;
  title: string;
  type: string;
  status: string;
}

export interface GlobalSearchResult {
  emails: GlobalSearchEmail[];
  contacts: GlobalSearchContact[];
  leads: GlobalSearchLead[];
  reports: GlobalSearchReport[];
}

export function useGlobalSearch(q: string) {
  return useQuery<GlobalSearchResult>({
    queryKey: ['global-search', q],
    queryFn: () => api.get<GlobalSearchResult>(`/api/search?q=${encodeURIComponent(q)}`),
    enabled: q.length >= 2,
    staleTime: 5000,
    placeholderData: { emails: [], contacts: [], leads: [], reports: [] },
  });
}

export function useMergeCandidates(contactId: number | null) {
  return useQuery<Array<{ id: number; fullName: string | null; primaryEmail: string | null; businessName: string | null; score: number; matchReason: string }>>({
    queryKey: ['merge-candidates', contactId],
    queryFn: () => api.get(`/api/contacts/${contactId!}/merge-candidates`),
    enabled: contactId !== null && contactId > 0,
    staleTime: 30000,
  });
}
